import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { PSTFieldNames } from '@src/suite/common/data-models/fields/pst-field-names';
import { StoryOutputType } from '@src/suite/common/enums/enums';

import { IconComponent } from './icon';

@Component({
    selector: 'st-story-icon',
    templateUrl: './story-icon.html',
    styleUrls: ['./icon.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-icon',
    },
})
export class StoryIconComponent extends IconComponent {
    data = input<StorytellingStoryRecord>();

    protected pstFieldName = PSTFieldNames.PSTStoryOutputType;

    calculatedType = computed(() => {
        return this.data()?.PSTStoryOutputType || this.type() || StoryOutputType.BROADCAST;
    });

    hasValue = computed(() => {
        return !!this.data()?.PSTStoryOwner?.length;
    });
}
